import React from 'react'

const No_Record_Found_Page = ({noRecordTitle = 'No Record Found', noRecordDescription,height= "100%"}) => {
    return (
        <>
            <div style={{
                display: "flex",
                flexDirection: 'column',
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                height: height,
                // position: "absolute",
                // left: "50%",
            }}>
                <h3>{noRecordTitle}</h3>
                <p>{noRecordDescription}</p>
            </div>
        </>
    )
}

export default No_Record_Found_Page;